module.exports = __webpack_public_path__ + "img/img_live_default.7471e009.svg";